/*
  VN2 Theme (Runde 2, Light/Dark Runtime-Logik)
  Der No-FOUC-Initialwert wird bereits inline in snippets/vn2-theme-init.liquid
  gesetzt (vor First Paint). Diese Datei uebernimmt nur die Laufzeit:
  Toggle-Buttons, Live-Sync mit der System-Preference (solange der Nutzer
  nicht selbst gewaehlt hat) und das Nachziehen von meta[name=theme-color].
*/
(function () {
  'use strict';
  if (window.VN2Theme) return;

  var STORAGE_KEY = 'vn2-theme';
  var root = document.documentElement;
  var mq = window.matchMedia ? matchMedia('(prefers-color-scheme: dark)') : null;

  function stored() {
    try {
      var v = localStorage.getItem(STORAGE_KEY);
      return (v === 'dark' || v === 'light') ? v : null;
    } catch (e) { return null; }
  }

  function systemTheme() {
    return mq && mq.matches ? 'dark' : 'light';
  }

  function current() {
    return root.getAttribute('data-vn2-theme') || 'light';
  }

  // meta[name=theme-color] ohne media-Attribut, von JS gepflegt: gewinnt bei
  // explizit gewaehltem Modus ueber die media-scoped Tags im <head>.
  var metaColor = null;
  function updateMeta(theme) {
    if (!metaColor) {
      metaColor = document.createElement('meta');
      metaColor.setAttribute('name', 'theme-color');
      metaColor.id = 'vn2-theme-color';
      document.head.appendChild(metaColor);
    }
    metaColor.setAttribute('content', theme === 'dark' ? '#1D1D1D' : '#FAF7F0');
  }

  function syncButtons(theme) {
    var pressed = theme === 'dark' ? 'true' : 'false';
    document.querySelectorAll('[data-vn2-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', pressed);
      var label = theme === 'dark' ? 'Zu hellem Modus wechseln' : 'Zu dunklem Modus wechseln';
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
    });
  }

  function apply(theme, persist) {
    root.setAttribute('data-vn2-theme', theme);
    if (persist) {
      try { localStorage.setItem(STORAGE_KEY, theme); } catch (e) {}
    }
    updateMeta(theme);
    syncButtons(theme);
    document.dispatchEvent(new CustomEvent('vn2:themechange', { detail: { theme: theme } }));
  }

  function toggle() {
    apply(current() === 'dark' ? 'light' : 'dark', true);
  }

  // Live-Sync mit dem System, solange der Nutzer NICHT selbst gewaehlt hat.
  if (mq) {
    var onChange = function () { if (!stored()) apply(systemTheme(), false); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }

  // Delegierter Klick-Handler: fasst auch Toggle-Buttons, die erst durch
  // Section-Rendering (Theme-Editor) in den DOM kommen.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-vn2-theme-toggle]');
    if (t) { e.preventDefault(); toggle(); }
  });

  function initButtons() { syncButtons(current()); updateMeta(current()); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtons);
  } else {
    initButtons();
  }
  document.addEventListener('shopify:section:load', function () { syncButtons(current()); });

  window.VN2Theme = { toggle: toggle, set: function (t) { apply(t, true); }, get: current };
})();
